import Cookies from 'js-cookie';
import React, { FC, PropsWithChildren } from 'react';

import type { ContentfulFileType, PageProps } from '@/types';

import { CookiesConsent } from './cookies-consent';
import { Footer } from './footer';
import { HeadMeta } from './head-meta';
import { Header } from './header';
import { SimpleFooter } from './simple-footer';
import { SimpleHeader } from './simple-header';

export const Layout: FC<PropsWithChildren<PageProps>> = (props) => {
  const [isCookieMissing, setIsCookieMissing] = React.useState(false);
  const [showCookiesConsent, setShowCookiesConsent] = React.useState(false);

  React.useEffect(() => {
    if (
      Cookies.get('analytics-and-performance') === undefined ||
      Cookies.get('functionality') === undefined ||
      Cookies.get('necessary') === undefined ||
      Cookies.get('targeting') === undefined
    ) {
      setIsCookieMissing(true);
    }
  }, []);

  const meta = (props.data as any).meta as {
    title?: string;
    description?: string;
    image?: ContentfulFileType;
  };

  const isLeadGenPage = props.meta.componentName === 'LeadGen';
  const header = isLeadGenPage ? (
    <SimpleHeader data={props.meta.translation.header} />
  ) : (
    <Header data={props.meta.translation.header} />
  );
  const footer = isLeadGenPage ? (
    <SimpleFooter data={props.meta.translation.simpleFooter} />
  ) : (
    <Footer data={props.meta.translation.footer} />
  );

  return (
    <div className="layout">
      <HeadMeta
        title={meta?.title || (props.data as any)?.title}
        description={meta?.description}
        image={
          meta?.image?.file?.url ? `https:${meta?.image?.file?.url}` : undefined
        }
      />
      {(showCookiesConsent || isCookieMissing) && (
        <CookiesConsent
          onClose={() => {
            setShowCookiesConsent(false);
            setIsCookieMissing(false);
          }}
          cookiesPolicyUrl={props.meta.translation.footer.cookiesPolicy}
        />
      )}
      {header}
      <main className="layout--main">
        <div>{props.children}</div>
      </main>
      {footer}
    </div>
  );
};
